module.exports = __webpack_public_path__ + "img/hero1.d226b8c6.png";